export class Colors {
  static colorD0DF00 = '#D0DF00'
  static color0D0D0E = '#0D0D0E'
  static color121213 = '#121213'
  static color23221F = '#23221F'
  static color373737 = '#373737'
  static color5A5957 = '#5A5957'
  static color91908F = '#91908F'
  static colorD7D9DB = '#D7D9DB'
  static colorF5F5F6 = '#F5F5F6'
  static colorCE492C = '#CE492C'
  static color1A1A18 = '#1A1A18'
  static colorC2D15B = '#C2D15B'
  static color7E7E80 = '#7E7E80'
  static color2F2F31 = '#2F2F31'
  static color272727 = '#272727'
  static color8c8c8c = '#8c8c8c'
  static colorFFEB3B = '#FFEB3B'
  static colorAAA8A1 = '#AAA8A1'
  static colorFAF9F5 = '#FAF9F5'
  static colorD9D9D9 = '#D9D9D9'
  static color8B0000 = '#8B0000'
  static colorCE492CB2 = '#CE492CB2'
  static colorFA5A37 = '#FA5A37'

  // alias
  static yellow = Colors.colorD0DF00
  static red = Colors.colorCE492C
}

export function getColorWithAlpha(color: string, alpha: number) {
  // カラーコードをRGBに分割
  const hexCode = color.replace('#', '')
  const r = parseInt(hexCode.substring(0, 2), 16)
  const g = parseInt(hexCode.substring(2, 4), 16)
  const b = parseInt(hexCode.substring(4, 6), 16)

  alpha = Math.min(1, Math.max(0, alpha))
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
